import "./TrialExpiringSystemPromptComponent.scss";
import template from "./TrialExpiringSystemPromptComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {ReplaySubject} from "rxjs";
import {UserStripeService} from "../../../../../stripe/service/UserStripeService";
import {DateTimeUtil} from "../../../../../js/util/DateTimeUtil";

export const TrialExpiringPrompt = "tfTrialExpiringPrompt";
export const RemainingDaysToShowPrompt = 5;

export function trialExpiringPrompt(): IComponentOptions {
    return {
        template,
        bindings: {
            daysLeft: "<"
        },
        controllerAs: "ctrl",
        controller: TrialExpiringSystemPromptComponentController
    };
}

export class TrialExpiringSystemPromptComponentController implements IOnDestroy {
    private readonly destroy$ = new ReplaySubject<boolean>(1);
    public daysLeft: number;
    public isLessThanADay: boolean;
    /** @ngInject */
    public constructor(private readonly userStripeService: UserStripeService) {
        userStripeService.currentSubscriptions().then(subs => {
            const preciseDaysLeft = DateTimeUtil.preciseDaysBetween(new Date(), new Date(subs[0].trialEnds));
            this.isLessThanADay = preciseDaysLeft < 1;
            this.daysLeft = Math.round(preciseDaysLeft);
        });
    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
